import { render, staticRenderFns } from "./KnColumnLabelsRow.vue?vue&type=template&id=03667984"
import script from "./KnColumnLabelsRow.vue?vue&type=script&lang=js"
export * from "./KnColumnLabelsRow.vue?vue&type=script&lang=js"
import style0 from "./KnColumnLabelsRow.vue?vue&type=style&index=0&id=03667984&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports